import React from 'react'
import SportsLayoutComp from '../../../components/sports/sports layout/SportsLayoutComp'

const Cycling = () => {
  return (
    <SportsLayoutComp name={'Cycling'}/>
  )
}

export default Cycling